import {
  DATA_EXPORT_REQUEST,
  DATA_EXPORT_SUCCESS,
  DATA_EXPORT_FAIL,
  DATA_IMPORT_REQUEST,
  DATA_IMPORT_SUCCESS,
  DATA_IMPORT_FAIL,
  GET_COLLECTIONS_REQUEST,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAIL,
  GET_COLLECTION_COUNT_REQUEST,
  GET_COLLECTION_COUNT_SUCCESS,
  GET_COLLECTION_COUNT_FAIL,
  CLEAR_DATA_OPERATIONS
} from '../actions/types';

const initialState = {
  collections: [],
  collectionCounts: {},
  exportLoading: false,
  importLoading: false,
  collectionsLoading: false,
  lastExportInfo: null,
  lastImportResult: null,
  error: null,
  message: null
};

export default function dataImportExportReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_COLLECTIONS_REQUEST:
      return {
        ...state,
        collectionsLoading: true,
        error: null
      };
    
    case GET_COLLECTIONS_SUCCESS:
      return {
        ...state,
        collections: payload,
        collectionsLoading: false,
        error: null
      };
    
    case GET_COLLECTIONS_FAIL:
      return {
        ...state,
        collectionsLoading: false,
        error: payload
      };

    case DATA_EXPORT_REQUEST:
      return {
        ...state,
        exportLoading: true,
        error: null,
        message: null
      };
    
    case DATA_EXPORT_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        lastExportInfo: payload.exportInfo,
        message: payload.message,
        error: null
      };
    
    case DATA_EXPORT_FAIL:
      return {
        ...state,
        exportLoading: false,
        error: payload
      };

    case DATA_IMPORT_REQUEST:
      return {
        ...state,
        importLoading: true,
        error: null,
        message: null
      };
    
    case DATA_IMPORT_SUCCESS:
      return {
        ...state,
        importLoading: false,
        lastImportResult: payload,
        message: 'Data imported successfully',
        error: null
      };
    
    case DATA_IMPORT_FAIL:
      return {
        ...state,
        importLoading: false,
        error: payload
      };

    case GET_COLLECTION_COUNT_REQUEST:
      return {
        ...state,
        error: null
      };
    
    case GET_COLLECTION_COUNT_SUCCESS:
      return {
        ...state,
        collectionCounts: {
          ...state.collectionCounts,
          [payload.collection]: payload.count
        },
        error: null
      };
    
    case GET_COLLECTION_COUNT_FAIL:
      return {
        ...state,
        error: payload
      };

    case CLEAR_DATA_OPERATIONS:
      return {
        ...state,
        lastExportInfo: null,
        lastImportResult: null,
        error: null,
        message: null
      };

    default:
      return state;
  }
}
